<div class="top-bar">
  <input nz-input placeholder="What can I do for you?" class="top-bar__input" />
  <div class="top-bar__icons">
   <button nz-button *ngIf="isShowNotif()"
     nzType="text"
     nzShape="circle"
     style="cursor: pointer"
     (click)="onShowCommunications()">
     <span style="position: relative; display: inline-block;">
       <i nz-icon nzType="comment" class="fs-16"></i>
       <nz-badge
         [nzCount]="notificationFromSRSCount"
         [nzOverflowCount]="99"
         nzSize="small"
         style="position: absolute; top: -6px; right: -6px;">
       </nz-badge>
     </span>
   </button>
   <button nz-button nzType="text" nzShape="circle" nzSize="large" (click)="onShowNotifications()" *ngIf="isShowCom()">
     <span style="position: relative; display: inline-block;">
       <i nz-icon nzType="bell" class="fs-16"></i>
       <nz-badge
         [nzCount]="notificationCount"
         [nzOverflowCount]="99"
         nzSize="small"
         style="position: absolute; top: -6px; right: -6px;">
       </nz-badge>
     </span>
   </button>
    <div nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click">
      <span class="cursor-pointer" style="margin-right: 10px">{{userInfo?.firstName}} {{userInfo?.lastName}}</span>
      <nz-avatar nzIcon="user" class="cursor-pointer"></nz-avatar>
    </div>

    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item (click)="logOut()">
          <i nz-icon nzType="logout" class="mr-8"></i>
          Logout
        </li>
      </ul>
    </nz-dropdown-menu>

  </div>
</div>
